
import { defineComponent } from 'vue'
import { request } from '@/store/case'

export default defineComponent({
  props: {
    hideHeader: { type: Boolean, required: false, default: false },
    classes: { type: Array, required: false, default: null }
  },
  setup() {
    return {
      request
    }
  }
})
